/* import { firestoreAction } from 'vuexfire';
import { fbAuth, fbDB } from '../../firebase'; */

const state = {
  restaurants: [],
};

const getters = {};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
